'use client';

import { ImageGridCell } from '@pixum/imagegrid';
import type { ImageInformation } from 'stores/express-designer';

const TRANSPARENT_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

interface UploadedImageProps {
  image: ImageInformation;
  isSelected: boolean;
  onSelect: (imageId: string) => void;
}

export function UploadedImage({ image, isSelected, onSelect }: UploadedImageProps) {
  const progressInPercent =
    image.isUpload && image.totalBytes ? Math.round(((image.uploadedBytes ?? 0) / image.totalBytes) * 100) : undefined;

  const handleSelect = () => onSelect(image.uuid);

  return (
    <ImageGridCell
      id={image.uuid}
      url={image.urlThumbBig ?? TRANSPARENT_PLACEHOLDER}
      isSelected={isSelected}
      isUpload={image.isUpload}
      progressInPercent={progressInPercent}
      uploadErrorType={image.uploadErrorType}
      onClick={handleSelect}
    />
  );
}
